export default "__VITE_ASSET__BKM0tH4e__"